import { baseURL } from '..';
import { IProject } from '../../shared/iProject';
import { IResult } from '../../shared/iResult';
import httpClient, { IResponse } from '../httpClient';
import { createHeaders, createRequest } from '../util';
import { IGetCalculateAsync } from './iApiRequest';

const calculationProvider = () => {
    const getCalculateAsync = async (payload: IGetCalculateAsync): Promise<IResponse<IResult>> =>
        httpClient.postAsync(createRequest(baseURL, '/Calculation', payload), createHeaders());

    return { getCalculateAsync };
};

export default calculationProvider();
